import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Icon } from "@/components/Icon";


export default function ProviderSandbox() {
  const { gameId } = useParams();
  const [params] = useSearchParams();
  const hasSession = Boolean(params.get("session"));

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#09090b] p-6 text-white">
      <div className="w-full max-w-lg rounded-3xl border border-[#27272A] bg-[#141417] p-8 text-center shadow-2xl">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#00D632]/10">
          <Icon name="shield-check" size={28} className="text-[#00D632]" />
        </div>
        <p className="text-xs font-black uppercase tracking-[0.2em] text-[#71717a]">
          PRYMEBET Provider Sandbox
        </p>
        <h1 className="mt-2 font-display text-3xl font-black tracking-tight">{gameId}</h1>
        <p className="mt-4 text-sm leading-6 text-[#a1a1aa]">
          This page proves the provider launch handoff and iframe host without using a commercial vendor.
          Wallet callbacks are certified separately through the signed mock-provider test harness.
        </p>
        <div className="mt-6 rounded-xl border border-[#27272A] bg-black/30 px-4 py-3 text-sm">
          Session token: <b className={hasSession ? "text-[#00D632]" : "text-[#EF4444]"}>
            {hasSession ? "present" : "missing"}
          </b>
        </div>
      </div>
    </div>
  );
}
